module.exports = __webpack_public_path__ + "media/images/adult-header-f606adb47ec4f6ffd58d94ce0bedf956.jpg";